export default __webpack_public_path__ + "static/media/new-publish-icon.1e2afdba.svg";